import { grey } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import { breakpointsMax } from './components/styles';
import modularScale from './helper/modularScale';

const BreakPointsMax = breakpointsMax();

/**
 * www.schnoffle.de default theme
 * @type {{}}
 */

/**
 * current scale
 * 0: 0.15em
 * 1: 0.19em
 * 2: 0.24em
 * 3: 0.31em
 * 4: 0.38em
 * 5: 0.5em
 * 6: 0.62em
 * 7: 0.81em
 * 8: 1em
 * 9: 1.31em
 * 10: 1.62em
 * 11: 2.12em
 * 12: 2.62em
 * 13: 3.43em
 * 14: 4.24em
 * 15: 5.54em
 * 16: 6.85em
 * 17: 8.97em
 * 18: 11.09em
 * 19: 14.52em
 * 20: 17.94em
 * 21: 23.49em
 * 22: 29.03em
 * 23: 38em
 * 24: 46.97em
 * 25: 61.48rem
 * 99.48rem: 76 rem
 * 27: 99.48rem
 * 28: 122.97rem
 */
const scale = [];

for (let i = -5; i < 24; i++) {
    scale.push(`${Math.round(modularScale(i, {
        base: [0.5, 1],
        ratio: 1.618,
    }) * 100) / 100}rem`);
}

const fontSizes = [];

for (let i = -5; i < 20; i++) {
    fontSizes.push(`${Math.round(modularScale(i, {
        base: [0.5, 1],
        ratio: 1.618,
    }) * 100) / 100}em`);
}

const options = {
    palette: {
        common: {
            transparent: 'rgba(0, 0, 0, 0)',
            fullBlack: 'rgba(0, 0, 0, 1)',
            darkBlack: 'rgba(0, 0, 0, 0.87)',
            middleBlack: 'rgba(0, 0, 0, 0.75)',
            lightBlack: 'rgba(0, 0, 0, 0.54)',
            minBlack: 'rgba(0, 0, 0, 0.26)',
            faintBlack: 'rgba(0, 0, 0, 0.12)',
            fullWhite: 'rgba(255, 255, 255, 1)',
            lightWhite: 'rgba(255, 255, 255, 0.87)',
            darkWhite: 'rgba(255, 255, 255, 0.54)',
            black: '#000000',
            white: '#FFFFFF',
            light: '#DDDDDD',
            middle: '#333333',
            dark: '#333333',
            primary: '#607D8B',
            primarylight: '#CFD8DC',
            primarydark: '#263238',
            secondary: '#009688',
            secondarylight: '#66c0b7',
            secondarydark: '#00695f',
            lightaccent: '#d5cf99',
            lightshade: '#F3F3F0',
            darkshade: '#232F41',
            text: '#455A64',
            info: '#00cc66',
        },
        primary: Object.assign(grey, {
            light: grey[300],
            main: grey[500],
            dark: grey[700],
            contrastText: '#444444',
        }),
        secondary: Object.assign({}, {
            50: '#FAEFF3',
            100: '#F2D0DB',
            200: '#F0C9D5',
            300: '#E193AB',
            400: '#D1557B',
            500: '#BA335C',
            600: '#9A294C',
            700: '#731F39',
            800: '#55172A',
            900: '#3D101E',
            light: '#E193AB',
            main: '#BA335C',
            dark: '#731F39',
            contrastText: '#FFFFFF',
            A100: '#FAF1EE',
            A200: '#F8EBE6',
            A400: '#F7E5DF',
            A500: '#EFCDBF',
            A700: '#D06439',
            A900: '#4F2412',
            RGBa: 'rgab(186,51,92,1.0)',
        }),
        blueGrey: grey,
        buttonSecondary: Object.assign(grey, {
            light: '#F7E5DF',
            main: '#D06439',
            dark: '#4F2412',
            contrastText: '#FFFFFF',
        }),
        info: '#1B6429',
        background: {
            default: '#FAF4F0',
            paper: '#fff',
            appBar: '#F2D0DB',
            contentFrame: '#FBF2EF',
        },
        shades: {
            light: {
                background: {
                    default: '#FAF4F0',
                    paper: '#fff',
                    appBar: '#F2D0DB',
                    contentFrame: '#FBF2EF',
                },
            },
        },
    },
    breakpoints: {
        keys: [
            'xs', 'sm', 'md', 'lg', 'xl'],
        values: BreakPointsMax,
    },
    space: scale,
    fontSizes,
    radius: 2,
    font: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    serif: '"Playfair Display", "Caslon", "Big Caslon", "Book Antiqua","Palatino Linotype","Georgia", "system-ui", serif',
    condensed: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    monospace: '"Lucida Console", "Andale Mono", "Roboto Mono", Menlo, monospace',
    typography: {
        fontFamily: '"Mulish",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        fontSize: '1em',
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        display4: {
            fontSize: '2.62em',
            fontWeight: 300,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            letterSpacing: '-.04em',
            lineHeight: 1,
            color: 'rgba(0, 0, 0, 0.54)',
        },
        display3: {
            fontSize: '2.12em',
            fontWeight: 400,
            fontFamily: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            letterSpacing: '-.02em',
            lineHeight: 1.31,
            color: 'rgba(0, 0, 0, 0.54)',
        },
        display2: {
            fontSize: '1.62em',
            fontWeight: 400,
            fontFamily: '"Mulish",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.31',
            color: 'rgba(0, 0, 0, 0.54)',
        },
        display1: {
            fontSize: '1.31em',
            fontWeight: 400,
            fontFamily: '"Mulish",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.31',
            color: 'rgba(0, 0, 0, 0.54)',
        },
        headline: {
            fontSize: '1.61rem',
            fontWeight: 700,
            fontFamily: '"Playfair Display",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.3',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        title: {
            fontSize: '1.31em',
            fontWeight: 500,
            fontFamily: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: 1,
            color: 'rgba(0, 0, 0, 0.87)',
        },
        subheading: {
            fontSize: '1rem',
            fontWeight: 400,
            fontFamily: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.31',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        body2: {
            fontSize: '1em',
            fontWeight: 500,
            fontFamily: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.62',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        body1: {
            fontSize: '1em',
            fontWeight: 400,
            fontFamily: '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            lineHeight: '1.62',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        caption: {
            fontSize: '0.8em',
            fontWeight: 400,
            fontFamily: '"Playfair Display", "Caslon", "Big Caslon", "Book Antiqua","Palatino Linotype","Georgia", "system-ui", serif',
            lineHeight: 1,
            color: 'rgba(0, 0, 0, 0.54)',
            textAlign: 'center',
        },
        button: {
            fontSize: '1em',
            textTransform: 'uppercase',
            fontWeight: 300,
            fontFamily: '"Mulish",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        },
    },
};

export const muiTheme = createMuiTheme(options);

// For styled componenents we need an different breakpoints property.
export const styledTheme = Object.assign({}, muiTheme,
    { breakpoints: BreakPointsMax },
);

/**
 const muiThemeTemplateSample = {
    "direction"  : "ltr",
    "palette"    : {
        "common"    : {
            "black"      : "#000",
            "white"      : "#fff",
            "transparent": "rgba(0, 0, 0, 0)",
            "fullBlack"  : "rgba(0, 0, 0, 1)",
            "darkBlack"  : "rgba(0, 0, 0, 0.87)",
            "lightBlack" : "rgba(0, 0, 0, 0.54)",
            "minBlack"   : "rgba(0, 0, 0, 0.26)",
            "faintBlack" : "rgba(0, 0, 0, 0.12)",
            "fullWhite"  : "rgba(255, 255, 255, 1)",
            "darkWhite"  : "rgba(255, 255, 255, 0.87)",
            "lightWhite" : "rgba(255, 255, 255, 0.54)",
            black         : '#000000',
            white         : '#FFFFFF',
            light         : '#DDDDDD',
            middle        : '#333333',
            dark          : '#333333',
            primary       : "#CC0066",
            primarylight  : "#FF5293",
            primarydark   : "#95003C",
            secondary     : "#00bcd4",
            secondarylight: "#62EFFF",
            secondarydark : "#008BA3",
            lightaccent   : "#C8AEA0",
            lightshade    : "#F3F3F0",
            darkshade     : "#232F41",
            text          : "#444444",
            info          : "#00cc66",
        },
        "type"      : "light",
        "primary"   : {
            "50"                  : "#e3f2fd",
            "100"                 : "#bbdefb",
            "200"                 : "#90caf9",
            "300"                 : "#64b5f6",
            "400"                 : "#42a5f5",
            "500"                 : "#2196f3",
            "600"                 : "#1e88e5",
            "700"                 : "#1976d2",
            "800"                 : "#1565c0",
            "900"                 : "#0d47a1",
            "A100"                : "#82b1ff",
            "A200"                : "#448aff",
            "A400"                : "#2979ff",
            "A700"                : "#2962ff",
            "contrastDefaultColor": "light"
        },
        "secondary" : {
            "50"                  : "#fce4ec",
            "100"                 : "#f8bbd0",
            "200"                 : "#f48fb1",
            "300"                 : "#f06292",
            "400"                 : "#ec407a",
            "500"                 : "#e91e63",
            "600"                 : "#d81b60",
            "700"                 : "#c2185b",
            "800"                 : "#ad1457",
            "900"                 : "#880e4f",
            "A100"                : "#ff80ab",
            "A200"                : "#ff4081",
            "A400"                : "#f50057",
            "A700"                : "#c51162",
            "contrastDefaultColor": "light"
        },
        "error"     : {
            "50"                  : "#ffebee",
            "100"                 : "#ffcdd2",
            "200"                 : "#ef9a9a",
            "300"                 : "#e57373",
            "400"                 : "#ef5350",
            "500"                 : "#f44336",
            "600"                 : "#e53935",
            "700"                 : "#d32f2f",
            "800"                 : "#c62828",
            "900"                 : "#b71c1c",
            "A100"                : "#ff8a80",
            "A200"                : "#ff5252",
            "A400"                : "#ff1744",
            "A700"                : "#d50000",
            "contrastDefaultColor": "light"
        },
        "grey"      : {
            "50"                  : "#fafafa",
            "100"                 : "#f5f5f5",
            "200"                 : "#eeeeee",
            "300"                 : "#e0e0e0",
            "400"                 : "#bdbdbd",
            "500"                 : "#9e9e9e",
            "600"                 : "#757575",
            "700"                 : "#616161",
            "800"                 : "#424242",
            "900"                 : "#212121",
            "A100"                : "#d5d5d5",
            "A200"                : "#aaaaaa",
            "A400"                : "#303030",
            "A700"                : "#616161",
            "contrastDefaultColor": "dark"
        },
        "shades"    : {
            "dark" : {
                "text"      : {
                    "primary"     : "rgba(255, 255, 255, 1)",
                    "secondary"   : "rgba(255, 255, 255, 0.7)",
                    "disabled"    : "rgba(255, 255, 255, 0.5)",
                    "hint"        : "rgba(255, 255, 255, 0.5)",
                    "icon"        : "rgba(255, 255, 255, 0.5)",
                    "divider"     : "rgba(255, 255, 255, 0.12)",
                    "lightDivider": "rgba(255, 255, 255, 0.075)"
                },
                "input"     : {
                    "bottomLine": "rgba(255, 255, 255, 0.7)",
                    "helperText": "rgba(255, 255, 255, 0.7)",
                    "labelText" : "rgba(255, 255, 255, 0.7)",
                    "inputText" : "rgba(255, 255, 255, 1)",
                    "disabled"  : "rgba(255, 255, 255, 0.5)"
                },
                "action"    : {
                    "active"  : "rgba(255, 255, 255, 1)",
                    "disabled": "rgba(255, 255, 255, 0.3)"
                },
                "background": {
                    "default"     : "#303030",
                    "paper"       : "#424242",
                    "appBar"      : "#212121",
                    "contentFrame": "#212121",
                    "status"      : "#000"
                }
            },
            "light": {
                "text"      : {
                    "primary"     : "rgba(0, 0, 0, 0.87)",
                    "secondary"   : "rgba(0, 0, 0, 0.54)",
                    "disabled"    : "rgba(0, 0, 0, 0.38)",
                    "hint"        : "rgba(0, 0, 0, 0.38)",
                    "icon"        : "rgba(0, 0, 0, 0.38)",
                    "divider"     : "rgba(0, 0, 0, 0.12)",
                    "lightDivider": "rgba(0, 0, 0, 0.075)"
                },
                "input"     : {
                    "bottomLine": "rgba(0, 0, 0, 0.42)",
                    "helperText": "rgba(0, 0, 0, 0.54)",
                    "labelText" : "rgba(0, 0, 0, 0.54)",
                    "inputText" : "rgba(0, 0, 0, 0.87)",
                    "disabled"  : "rgba(0, 0, 0, 0.42)"
                },
                "action"    : {
                    "active"  : "rgba(0, 0, 0, 0.54)",
                    "disabled": "rgba(0, 0, 0, 0.26)"
                },
                "background": {
                    "default"     : "#fafafa",
                    "paper"       : "#fff",
                    "appBar"      : "#f5f5f5",
                    "contentFrame": "#eeeeee"
                }
            }
        },
        "text"      : {
            "primary"     : "rgba(0, 0, 0, 0.87)",
            "secondary"   : "rgba(0, 0, 0, 0.54)",
            "disabled"    : "rgba(0, 0, 0, 0.38)",
            "hint"        : "rgba(0, 0, 0, 0.38)",
            "icon"        : "rgba(0, 0, 0, 0.38)",
            "divider"     : "rgba(0, 0, 0, 0.12)",
            "lightDivider": "rgba(0, 0, 0, 0.075)"
        },
        "input"     : {
            "bottomLine": "rgba(0, 0, 0, 0.42)",
            "helperText": "rgba(0, 0, 0, 0.54)",
            "labelText" : "rgba(0, 0, 0, 0.54)",
            "inputText" : "rgba(0, 0, 0, 0.87)",
            "disabled"  : "rgba(0, 0, 0, 0.42)"
        },
        "action"    : {
            "active"  : "rgba(0, 0, 0, 0.54)",
            "disabled": "rgba(0, 0, 0, 0.26)"
        },
        "background": {
            "default"     : "#fafafa",
            "paper"       : "#fff",
            "appBar"      : "#f5f5f5",
            "contentFrame": "#eeeeee"
        }
    },
    "typography" : {
        "fontFamily"       : '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        "fontSize"         : 16,
        "fontWeightLight"  : 300,
        "fontWeightRegular": 400,
        "fontWeightMedium" : 500,
        "display4"         : {
            "fontSize"     : 112,
            "fontWeight"   : 300,
            "fontFamily"   : '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "letterSpacing": "-.04em",
            "lineHeight"   : 1,
            "color"        : "rgba(0, 0, 0, 0.54)"
        },
        "display3"         : {
            "fontSize"     : 56,
            "fontWeight"   : 400,
            "fontFamily"   : '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "letterSpacing": "-.02em",
            "lineHeight"   : 1.35,
            "color"        : "rgba(0, 0, 0, 0.54)"
        },
        "display2"         : {
            "fontSize"  : 45,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "48px",
            "color"     : "rgba(0, 0, 0, 0.54)"
        },
        "display1"         : {
            "fontSize"  : 34,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "40px",
            "color"     : "rgba(0, 0, 0, 0.54)"
        },
        "headline"         : {
            "fontSize"  : 24,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "32px",
            "color"     : "rgba(0, 0, 0, 0.87)"
        },
        "title"            : {
            "fontSize"  : 21,
            "fontWeight": 500,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": 1,
            "color"     : "rgba(0, 0, 0, 0.87)"
        },
        "subheading"       : {
            "fontSize"  : 16,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "24px",
            "color"     : "rgba(0, 0, 0, 0.87)"
        },
        "body2"            : {
            "fontSize"  : 16,
            "fontWeight": 500,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "24px",
            "color"     : "rgba(0, 0, 0, 0.87)"
        },
        "body1"            : {
            "fontSize"  : 16,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": "20px",
            "color"     : "rgba(0, 0, 0, 0.87)"
        },
        "caption"          : {
            "fontSize"  : 14,
            "fontWeight": 400,
            "fontFamily": '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            "lineHeight": 1,
            "color"     : "rgba(0, 0, 0, 0.54)"
        },
        "button"           : {
            "fontSize"     : 16,
            "textTransform": "uppercase",
            "fontWeight"   : 500,
            "fontFamily"   : '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        }
    },
    "shadows"    : [
        "none",
        "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
        "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
        "0px 1px 8px 0px rgba(0, 0, 0, 0.2),0px 3px 4px 0px rgba(0, 0, 0, 0.14),0px 3px 3px -2px rgba(0, 0, 0, 0.12)",
        "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 5px 8px 0px rgba(0, 0, 0, 0.14),0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
        "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
        "0px 4px 5px -2px rgba(0, 0, 0, 0.2),0px 7px 10px 1px rgba(0, 0, 0, 0.14),0px 2px 16px 1px rgba(0, 0, 0, 0.12)",
        "0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
        "0px 5px 6px -3px rgba(0, 0, 0, 0.2),0px 9px 12px 1px rgba(0, 0, 0, 0.14),0px 3px 16px 2px rgba(0, 0, 0, 0.12)",
        "0px 6px 6px -3px rgba(0, 0, 0, 0.2),0px 10px 14px 1px rgba(0, 0, 0, 0.14),0px 4px 18px 3px rgba(0, 0, 0, 0.12)",
        "0px 6px 7px -4px rgba(0, 0, 0, 0.2),0px 11px 15px 1px rgba(0, 0, 0, 0.14),0px 4px 20px 3px rgba(0, 0, 0, 0.12)",
        "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)",
        "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px 4px rgba(0, 0, 0, 0.12)",
        "0px 7px 9px -4px rgba(0, 0, 0, 0.2),0px 14px 21px 2px rgba(0, 0, 0, 0.14),0px 5px 26px 4px rgba(0, 0, 0, 0.12)",
        "0px 8px 9px -5px rgba(0, 0, 0, 0.2),0px 15px 22px 2px rgba(0, 0, 0, 0.14),0px 6px 28px 5px rgba(0, 0, 0, 0.12)",
        "0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)",
        "0px 8px 11px -5px rgba(0, 0, 0, 0.2),0px 17px 26px 2px rgba(0, 0, 0, 0.14),0px 6px 32px 5px rgba(0, 0, 0, 0.12)",
        "0px 9px 11px -5px rgba(0, 0, 0, 0.2),0px 18px 28px 2px rgba(0, 0, 0, 0.14),0px 7px 34px 6px rgba(0, 0, 0, 0.12)",
        "0px 9px 12px -6px rgba(0, 0, 0, 0.2),0px 19px 29px 2px rgba(0, 0, 0, 0.14),0px 7px 36px 6px rgba(0, 0, 0, 0.12)",
        "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 20px 31px 3px rgba(0, 0, 0, 0.14),0px 8px 38px 7px rgba(0, 0, 0, 0.12)",
        "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 21px 33px 3px rgba(0, 0, 0, 0.14),0px 8px 40px 7px rgba(0, 0, 0, 0.12)",
        "0px 10px 14px -6px rgba(0, 0, 0, 0.2),0px 22px 35px 3px rgba(0, 0, 0, 0.14),0px 8px 42px 7px rgba(0, 0, 0, 0.12)",
        "0px 11px 14px -7px rgba(0, 0, 0, 0.2),0px 23px 36px 3px rgba(0, 0, 0, 0.14),0px 9px 44px 8px rgba(0, 0, 0, 0.12)",
        "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)"
    ],
    "transitions": {
        "easing"  : {
            "easeInOut": "cubic-bezier(0.4, 0, 0.2, 1)",
            "easeOut"  : "cubic-bezier(0.0, 0, 0.2, 1)",
            "easeIn"   : "cubic-bezier(0.4, 0, 1, 1)",
            "sharp"    : "cubic-bezier(0.4, 0, 0.6, 1)"
        },
        "duration": {
            "shortest"      : 150,
            "shorter"       : 200,
            "short"         : 250,
            "standard"      : 300,
            "complex"       : 375,
            "enteringScreen": 225,
            "leavingScreen" : 195
        }
    },
    "mixins"     : {},
    "spacing"    : {
        "unit": 8
    },
    "breakpoints": {
        "keys"  : [
            "xs",
            "sm",
            "md",
            "lg",
            "xl"
        ],
        "values": [
            360,
            600,
            960,
            1280,
            1920
        ]
    },
    "zIndex"     : {
        "mobileStepper": 900,
        "menu"         : 1000,
        "appBar"       : 1100,
        "drawerOverlay": 1200,
        "navDrawer"    : 1300,
        "dialogOverlay": 1400,
        "dialog"       : 1500,
        "layer"        : 2000,
        "popover"      : 2100,
        "snackbar"     : 2900,
        "tooltip"      : 3000
    }
}
 */



// WEBPACK FOOTER //
// ./src/theme.js